<template>
  <!-- Dialog 1 : Sélection de la SIM -->
  <DialogComponent
    ref="modalRef"
    type="modal"
    hideCloseButton
    mainClass="[&_.modalBox]:rounded-[40px]!"
    @closed="
      ({ source }) => {
        source !== 'filledButton' &&
          $bus.emit($constants.EVENTS.SERVICES.INITIATION.INITIATION_FAILED, {
            messageTitle: 'Transaction annulée',
            message: 'vous avez annulé la transaction'
          });
      }
    "
  >
    <div class="flex flex-col gap-4 overflow-y-auto max-h-[80vh] p-2">
      <div class="text-xl text-center font-bold text-gray-800 mb-2">
        Où lancer le paiement?
      </div>

      <!-- Loading state : détection des SIM -->
      <div v-if="isLoading" class="flex flex-col items-center gap-3 py-8">
        <div
          class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"
        ></div>
        <div class="text-sm text-gray-500">Détection des SIM en cours…</div>
      </div>

      <!-- Loading state : attente de l'initiation -->
      <div
        v-else-if="isWaitingInitiation"
        class="flex flex-col items-center gap-3 py-8"
      >
        <div
          class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"
        ></div>
        <div class="text-sm text-gray-500">
          Lancement de la transaction en cours…
        </div>
      </div>

      <!-- Options list -->
      <div v-else class="flex flex-col gap-2">
        <div
          v-for="(option, index) in options"
          :key="index"
          class="flex items-center gap-4 p-4 rounded-xl cursor-pointer transition-colors"
          @click="onOptionSelected(option)"
        >
          <!-- CAS 1 : Carte SIM (Forme trapèze) -->
          <template v-if="option.isSim">
            <div
              class="w-7 h-9 pt-2 flex items-center justify-center text-white font-bold text-sm shrink-0"
              :class="getSlotColorClass(index)"
              style="
                clip-path: polygon(0 0, 75% 0, 100% 25%, 100% 100%, 0 100%);
                border-radius: 2px;
              "
            >
              <div>
                {{ index + 1 }}
              </div>
            </div>
            <div class="font-medium text-gray-800">
              {{ option.label }}
            </div>
          </template>

          <!-- CAS 2 : Un autre téléphone (Icône téléphone) -->
          <template v-else-if="option.isOtherPhone">
            <div class="flex items-center gap-3 w-full">
              <svg
                class="w-7 h-9 text-gray-500 shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                ></path>
              </svg>
              <div class="font-medium text-gray-800">
                {{ option.label }}
              </div>
            </div>
          </template>

          <!-- CAS 3 : Cet appareil (fallback quand aucune SIM) -->
          <template v-else-if="option.isThisPhone">
            <div class="flex items-center gap-3 w-full">
              <svg
                class="w-7 h-9 text-gray-500 shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                ></path>
              </svg>
              <div class="font-medium text-gray-800">
                {{ option.label }}
              </div>
            </div>
          </template>
        </div>
      </div>

      <!-- Footer SimPilot -->
      <!-- <div class="text-center mt-4 pt-4 border-t border-gray-100">
        <a
          href="https://simpilot.tech"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex items-center gap-2 text-xs text-gray-400 hover:text-gray-600 transition-colors"
        >
          <span>Propulsé par</span>
          <img
            src="https://dashboard.simpilot.tech/logo-light.png"
            alt="SimPilot"
            class="h-4 w-auto"
          />
          <span>SimPilot</span>
        </a>

        
      </div> -->
    </div>
  </DialogComponent>

  <!-- Dialog 2 : Information pour payer depuis un autre appareil -->
  <DialogComponent
    ref="infoModalRef"
    type="modal"
    hideCloseButton
    mainClass="[&_.modalBox]:rounded-[40px]!"
    @closed="
      ({ source }) => {
        // Logique d'annulation si nécessaire
      }
    "
  >
    <div class="flex flex-col items-center gap-4 p-6 text-center">
      <!-- Icône d'information -->
      <div
        class="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mb-2"
      >
        <svg
          class="w-8 h-8 text-blue-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
      </div>

      <!-- Titre -->
      <h3 class="text-xl font-bold text-gray-900">
        Payer depuis l'autre appareil
      </h3>

      <!-- Description -->
      <p class="text-sm text-gray-500 max-w-xs">
        Utilisez ce code pour payer sur un autre appareil
      </p>

      <!-- Encadré du code USSD -->
      <div class="w-full mt-4">
        <div
          class="relative bg-gray-50 border border-gray-200 rounded-lg p-4 flex items-center justify-between"
        >
          <span
            class="font-mono text-lg font-semibold text-gray-800 select-all"
          >
            {{ ussdCode }}
          </span>
          <button
            @click="copyUssdCode"
            class="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
              />
            </svg>
          </button>
        </div>
        <p class="text-xs text-gray-400 mt-1">Appuyez pour copier</p>
      </div>

      <!-- Bouton Ok -->
      <button
        @click="onConfirmOtherPhone"
        class="w-full mt-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-xl transition-colors"
      >
        C'est fait
      </button>

      <!-- Footer SimPilot -->
      <!-- <div class="text-center mt-4 w-full border-t border-gray-100 pt-4">
        <a
          href="https://simpilot.tech"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex items-center gap-2 text-xs text-gray-400 hover:text-gray-600 transition-colors"
        >
          <span>Propulsé par</span>
          <img
            src="https://dashboard.simpilot.tech/logo-light.png"
            alt="SimPilot"
            class="h-4 w-auto"
          />
          <span>SimPilot</span>
        </a>
      </div> -->
    </div>
  </DialogComponent>

  <!-- Bus Helper -->
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.INITIATION.REQUEST_MANUAL_LAUNCH"
    :handler="
      () => {
        submitted = false;
        selectedPhoneOption = null;
        isWaitingInitiation = false;
        modalRef.show();
        $bus.emit($constants.EVENTS.USSD.REQUEST_SIMS_LIST);
      }
    "
  />

  <!-- Bus Helper -->
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.INITIATION.INITIATED"
    :handler="
      () => {
        onPaymentInitiated();
      }
    "
  />

  <!-- Bus Helper : reset du loading si l'initiation échoue -->
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.INITIATION.INITIATION_FAILED"
    :handler="
      () => {
        isWaitingInitiation = false;
      }
    "
  />
</template>

<script setup>
import { ref, computed, getCurrentInstance } from 'vue';
import Commons from '../../shared/libraries/commons';

const { proxy } = getCurrentInstance();
const { $bus, $constants, $stores } = proxy;

const modalRef = ref(null);
const infoModalRef = ref(null);
const submitted = ref(false);
const selectedPhoneOption = ref(null);

// Loading affiché entre la sélection d'une option et l'événement INITIATED
const isWaitingInitiation = ref(false);

const isLoading = computed(
  () => $stores.ussd?.state?.simsList?.isLoading || false
);

// ---------------------------------------------------------------
// BLOC DE TEST (commenté volontairement) - à décommenter pour tester
// ---------------------------------------------------------------
// const simList = computed(() => [
//   {
//     number: '',
//     subscriptionId: '1',
//     simSlotIndex: 0,
//     carrierName: 'MTN BENIN',
//     isoCountryCode: 'bj',
//     mobileCountryCode: '616',
//     mobileNetworkCode: '03'
//   },
//   {
//     number: '',
//     subscriptionId: '2',
//     simSlotIndex: 1,
//     carrierName: 'MTN BENIN',
//     isoCountryCode: 'bj',
//     mobileCountryCode: '616',
//     mobileNetworkCode: '03'
//   }
// ]);

// Source réelle des SIM depuis le store.
// Si data est null/undefined → on retombe sur un tableau vide,
// ce qui déclenchera le fallback "Cet appareil".
const simList = computed(() => $stores.ussd?.state?.simsList?.data || []);

const ussdCode = computed(
  () =>
    $stores.services.state.transactionInitiation.mobileMoneyOperationConfigs
      ?.manualOperationInstructions?.ussdCode || ''
);

/**
 * Construction des options :
 * - Si des SIMs sont détectées → une option par SIM (isSim: true)
 * - Sinon → une seule option "Cet appareil" (isThisPhone: true)
 * - Dans tous les cas → une option "Un autre téléphone" (isOtherPhone: true)
 */
const options = computed(() => {
  const list = [];

  if (simList.value.length) {
    simList.value.forEach((sim) => {
      list.push({
        label: sim.carrierName,
        subscriptionId: sim.subscriptionId,
        simSlotIndex: sim.simSlotIndex,
        isSim: true
      });
    });
  } else {
    // Aucune SIM trouvée → fallback "Cet appareil" cliquable
    list.push({ label: 'Cet appareil', isThisPhone: true });
  }

  list.push({ label: 'Un autre téléphone', isOtherPhone: true });
  return list;
});

const getSlotColorClass = (index) => {
  const colors = [
    'bg-green-600',
    'bg-pink-600',
    'bg-blue-600',
    'bg-purple-600'
  ];
  return colors[index % colors.length];
};

const copyUssdCode = () => {
  if (ussdCode.value) {
    Commons.copyToClipboard(ussdCode.value, () => {
      $bus.emit($constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
        title: 'Code copié',
        body: ussdCode.value
      });
    });
  }
};

const onOptionSelected = (option) => {
  selectedPhoneOption.value = option;

  isWaitingInitiation.value = true;
  $bus.emit($constants.EVENTS.SERVICES.INITIATION.MANUAL_LAUNCH_DONE);
};

const onPaymentInitiated = () => {
  if (
    !$stores.services.state.transactionInitiation.mobileMoneyOperationConfigs
      ?.requiresManualLaunch
  )
    return;

  modalRef.value.hide('filledButton');

  if (selectedPhoneOption.value.isOtherPhone) {
    setTimeout(()=>{
      infoModalRef.value.show();
    }, 1000)
    return;
  }

  // SIM détectée → lancer USSD avec slotIndex
  if (selectedPhoneOption.value.isSim) {
    $bus.emit($constants.EVENTS.SHARED.LAUNCHED_USSD, {
      ussdCode: ussdCode.value,
      slotIndex: selectedPhoneOption.value.simSlotIndex
    });
  }
  // "Cet appareil" (fallback sans SIM) → lancer USSD sans slotIndex
  else if (selectedPhoneOption.value.isThisPhone) {
    $bus.emit($constants.EVENTS.SHARED.LAUNCHED_USSD, {
      ussdCode: ussdCode.value
    });
  }

  validateDone(selectedPhoneOption.value);
};

const onConfirmOtherPhone = () => {
  infoModalRef.value.hide();
  validateDone({ isOtherPhone: true });
};

const validateDone = (option) => {
  submitted.value = true;
  isWaitingInitiation.value = false;
  if (modalRef.value) {
    modalRef.value.hide("filledButton");
  }
  if (infoModalRef.value) {
    infoModalRef.value.hide("filledButton");
  }
};
</script>